import { UploadOutlined } from "@ant-design/icons";
import { Button, Card, DatePicker, Input, InputNumber, Table, Upload } from "antd";
import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import { CSVLink } from "react-csv";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
    clearPayroll,
    loadAllPayslip
} from "../../redux/rtk/features/payroll/payrollSlice";
import PageTitle from "../page-header/PageHeader";
import UserPrivateComponent from "../PrivateRoutes/UserPrivateComponent";
import ColVisibilityDropdown from "../Shared/ColVisibilityDropdown";
import { CsvLinkBtn } from "../UI/CsvLinkBtn";
import * as XLSX from "xlsx";


function CustomTable({ list = [], loading }) {
    const [columnsToShow, setColumnsToShow] = useState([]);
    const dispatch = useDispatch();

    const [uploadedData, setUploadedData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [selectedMonth, setSelectedMonth] = useState(dayjs().month() + 1); // Default to current month
    const [selectedYear, setSelectedYear] = useState(dayjs().year()); // Default to current year


    const filterData = (data, month, year) => {
        console.log("inFilterData", data, month, year);
        const filtered = data.filter((item) => item.salaryMonth === month && item.salaryYear === year);
        console.log("afterFilter", filtered);
        setFilteredData(filtered);
    };


    const handleUpload = (file) => {
        console.log("Uploaded File:", file);

        if (!file) return;

        const reader = new FileReader();
        reader.onload = (e) => {
            const data = new Uint8Array(e.target.result);
            const workbook = XLSX.read(data, { type: "array" });

            const firstSheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[firstSheetName];

            const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

            if (jsonData.length > 0) {
                const headers = jsonData[0];
                const rows = jsonData.slice(1);

                const parsedData = rows.map((row) => {
                    return headers.reduce((acc, header, index) => {
                        // Map Excel headers to expected keys
                        const mappedHeader = {
                            "S.No": "serial",
                            "Employee ID": "employeeId",
                            "First Name": "firstName",
                            "Last Name": "lastName",
                            "Basic Salary": "salary",
                            "Loan Payment": "emi",
                            "Overtime Hours": "overtimeHours",
                            "Overtime Payable": "overtimePayable",
                            "Present Days": "presentDays",
                            "Salary Month": "salaryMonth",
                            "Salary Year": "salaryYear",
                            "Tax": "tax",
                            "Total Leaves Taken": "totalLeavesTaken",
                            "Total Payable": "totalPayable",
                            "Employee NI": "ni",
                            "Employer Ni": "employerNi",
                        }[header] || header; // Fallback to original if not mapped

                        acc[mappedHeader] = row[index] || "";
                        return acc;
                    }, {});
                });

                console.log("Parsed Excel Data:", parsedData);
                setUploadedData(parsedData);
                filterData(parsedData, selectedMonth, selectedYear);
            }
        };

        reader.readAsArrayBuffer(file);
    };





    const handleMonthYearChange = (date) => {
        const month = date.month() + 1;
        const year = date.year();
        setSelectedMonth(month);
        setSelectedYear(year);
        filterData(uploadedData, month, year);
    };

    const columns = [
        {
            title: "S.No",
            dataIndex: "serial",
            key: "serial",
        },
        {
            title: "Name",
            key: "name",
            render: (record) => `${record.firstName} ${record.lastName}`,
        },

        {
            title: "Basic Salary",
            dataIndex: "salary",
            key: "salary",
        },

        {
            title: "Basic Payable",
            dataIndex: "salaryPayable",
            key: "salaryPayable",
            render: (salaryPayable, { id }) => {
                return (
                    <div>
                        <InputNumber
                            size={"small"}
                            style={{ width: "110px", fontSize: "15px" }}
                            value={salaryPayable}
                            min={0}
                        />{" "}
                    </div>
                );
            },
        },

        {
            title: "Overtime Payable",
            dataIndex: "overtimePayable",
            key: "overtimePayable",
            render: (overtimePayable, { id }) => {

                return (
                    <div>
                        <InputNumber
                            size={"small"}
                            style={{ width: "110px", fontSize: "15px" }}
                            value={overtimePayable}
                            min={0}
                        />{" "}
                    </div>
                );
            },
        },

        {
            title: "Accommodation",
            dataIndex: "accommodation",
            key: "accommodation",
            render: (accommodation, { id }) => {
                return (
                    <div>
                        <InputNumber
                            size={"small"}
                            style={{ width: "100px", fontSize: "15px" }}
                            value={accommodation}
                            min={0}
                        />{" "}
                    </div>
                );
            },
        },

        {
            title: "Loan Payment",
            dataIndex: "emi",
            key: "emi",
            render: (emi, { id }) => {
                return (
                    <div>
                        <InputNumber
                            size={"small"}
                            style={{ width: "100px", fontSize: "15px" }}
                            value={emi}
                            min={0}
                        />
                    </div>
                );
            },
        },

        {
            title: "Tax",
            dataIndex: "tax",
            key: "tax",
            render: (tax, { id }) => {
                return (
                    <div>
                        <InputNumber
                            size={"small"}
                            style={{ width: "100px", fontSize: "15px" }}
                            value={tax}
                            min={0}
                        />
                    </div>
                );
            },
        },

        {
            title: "Employer NI",
            dataIndex: "employerNi",
            key: "employerNi",
            render: (employerNi, { id }) => {
                return (
                    <div>
                        <InputNumber
                            size={"small"}
                            style={{ width: "100px", fontSize: "15px" }}
                            value={employerNi}
                            min={0}
                        />
                    </div>
                );
            },
        },

        {
            title: "Employee NI",
            dataIndex: "ni",
            key: "ni",
            render: (ni, { id }) => {
                return (
                    <div>
                        <InputNumber
                            size={"small"}
                            style={{ width: "100px", fontSize: "15px" }}
                            value={ni}
                            min={0}
                        />
                    </div>
                );
            },
        },

        {
            title: "Total Payable",
            dataIndex: "totalPayable",
            key: "totalPayable",
        },
    ];

    useEffect(() => {
        setColumnsToShow(columns);
    }, []);

    const columnsToShowHandler = (val) => {
        setColumnsToShow(val);
    };

    // const addKeys = (arr) => arr.map((i) => ({ ...i, key: i.id }));
    const addKeys = (arr) => (Array.isArray(arr) ? arr : []).map((i, index) => ({ ...i, key: i.id || index, serial: index + 1 }));


    const exportData = (Array.isArray(list) ? list : []).map((item, index) => ({
        serial: index + 1,
        // id: item.id,
        firstName: item.firstName,
        lastName: item.lastName,
        employeeId: item.employeeId,
        salaryMonth: item.salaryMonth,
        salaryYear: item.salaryYear,
        salary: item.salary,
        presentDays: item.presentDays,
        // bonus: item.bonus,
        // bonusComment: item.bonusComment,
        // deduction: item.deduction,
        tax: item.tax,
        employerNi: item.employerNi,
        ni: item.ni,
        // deductionComment: item.deductionComment,
        overtimePayable: item.overtimePayable,
        overtimeHours: item.overtimeHours,
        emi: item.emi,
        totalPayable: item.totalPayable,
        totalLeavesTaken: item.totalLeavesTaken,
    }));

    const headers = [
        { label: "S.No", key: "serial" },
        { label: "ID", key: "id" },
        { label: "First Name", key: "firstName" },
        { label: "Last Name", key: "lastName" },
        { label: "Employee ID", key: "employeeId" },
        { label: "Salary Month", key: "salaryMonth" },
        { label: "Salary Year", key: "salaryYear" },
        { label: "Basic Salary", key: "salary" },
        { label: "Present Days", key: "presentDays" },
        { label: "Bonus", key: "bonus" },
        { label: "Bonus Comment", key: "bonusComment" },
        { label: "Deduction", key: "deduction" },
        { label: "Tax", key: "tax" },
        { label: "National Insurance", key: "ni" },
        { label: "Deduction Comment", key: "deductionComment" },
        { label: "Overtime Payable", key: "overtimePayable" },
        { label: "Overtime Hours", key: "overtimeHours" },
        { label: "EMI", key: "emi" },
        { label: "Total Payable", key: "totalPayable" },
        { label: "Total Leaves Taken", key: "totalLeavesTaken" },
    ];

    return (
        <div className="mt-5 mr-10">
            <div className="text-center my-2 flex justify-between">
                {list && (
                    <div style={{ marginBottom: "30px", marginRight: "30px"}}>
                        <ColVisibilityDropdown
                            options={columns}
                            columns={columns}
                            columnsToShowHandler={columnsToShowHandler}
                        />
                    </div>
                )}
                <DatePicker
                    picker="month"
                    defaultValue={dayjs()}
                    onChange={handleMonthYearChange}
                />
                    <div style={{ display: "flex", gap: "10px", alignItems: "center", marginLeft: "30px"}}>
                        <Upload
                            beforeUpload={(file) => {
                                handleUpload(file);
                                return false; // Prevent auto upload
                            }}
                            showUploadList={false} // Hide the file list
                        >
                            <Button icon={<UploadOutlined />}>Upload Excel</Button>
                        </Upload>

                    </div>

            </div>

            <Table
                scroll={{ x: true }}
                loading={loading}
                columns={columnsToShow}
                dataSource={addKeys(
                    filteredData.length
                        ? filteredData
                        : Array.isArray(list)
                            ? list
                            : []
                )}
                locale={{ emptyText: "No uploaded data found for the selected month and year" }}
                expandable={{
                    expandedRowRender: (record) => (
                        <div className="flex justify-start">
                            <div className="flex flex-col mr-10">
                                <div className="flex justify-between">
                                    <div className="font-bold">Paid Leave : </div>
                                    <div>{record.paidLeave}</div>
                                </div>
                                <div className="flex justify-between">
                                    <div className="font-bold">Unpaid Leave : </div>
                                    <div className="ml-2">{record.unpaidLeave}</div>
                                </div>
                            </div>

                            <div className="flex flex-col mr-10">
                                <div className="flex justify-between ">
                                    <div className="font-bold">M-Holiday : </div>
                                    <div>{record.monthlyHoliday}</div>
                                </div>
                                <div className="flex justify-between">
                                    <div className="font-bold">P-Holiday : </div>
                                    <div>{record.publicHoliday}</div>
                                </div>
                            </div>

                            <div className="flex flex-col mr-10">
                                <div className="flex justify-between">
                                    <div className="font-bold">Work Day : </div>
                                    <div className="ml-2">{record.workDay}</div>
                                </div>
                                <div className="flex justify-between">
                                    <div className="font-bold"> Shift W.H : </div>
                                    <div>{record.shiftWiseWorkHour}</div>
                                </div>
                            </div>

                            <div className="flex flex-col mr-10">
                                <div className="flex justify-between">
                                    <div className="font-bold">Total Present : </div>
                                    <div className="ml-2">{record.presentDays}</div>
                                </div>

                                <div className="flex justify-between">
                                    <div className="font-bold">O.T. Hours : </div>
                                    <div className="ml-2">{record.overtimeHours}</div>
                                </div>
                            </div>
                            <div className="flex flex-col mr-10">
                                <div className="flex justify-between">
                                    <div className="font-bold">Annual Leave : </div>
                                    <div className="ml-2">{record.totalLeavesTaken}</div>
                                </div>
                            </div>

                        </div>
                    ),
                    rowExpandable: (record) => record.name !== "Not Expandable",
                }}
            />
        </div>
    );
}

const UploadPaySlip = () => {
    const [month, setMonth] = useState(dayjs().format("M"));
    const [year, setYear] = useState(dayjs().format("YYYY"));
    const [loading, setLoading] = useState(false);

    const [dynamicAdditions, setDynamicAdditions] = useState({});
    const [dynamicDeductions, setDynamicDeductions] = useState({});
    const [updateTrigger, setUpdateTrigger] = useState(0);

    const payroll = useSelector((state) => state.payroll.list);
    const loader = useSelector((state) => state.payroll.loading);

    const dispatch = useDispatch();
    const [payslips, setPayslips] = useState([]);

    console.log("payrolDataThroughQueries", payroll);



    useEffect(() => {
        dispatch(loadAllPayslip({ month, year }));
        // dispatch(loadAllSalaryComponents())

        return () => {
            dispatch(clearPayroll());
        };
    }, [month, year, updateTrigger]);

    useEffect(() => {
        setPayslips(payroll);
        console.log("payslipStore", payslips)
    }, [payroll]);


    const onMonthChange = async (date, dateString) => {
        console.log("MonthDateString", dateString);

        // Map month names to their corresponding numbers
        const monthMapping = {
            Jan: 1,
            Feb: 2,
            Mar: 3,
            Apr: 4,
            May: 5,
            Jun: 6,
            Jul: 7,
            Aug: 8,
            Sep: 9,
            Oct: 10,
            Nov: 11,
            Dec: 12,
        };

        // Get the numeric month from the dateString
        const newMonth = monthMapping[dateString];
        console.log("newMonth", newMonth);
        // Set the month and dispatch the action
        setMonth(newMonth);

        dispatch(loadAllPayslip({ month: newMonth, year }));
    };


    const onYearChange = (date, dateString) => {
        console.log("YearDateString", dateString)
        setYear(dateString);
        dispatch(loadAllPayslip({ month, year: dateString }));
    };

    const navigate = useNavigate();

    const OnSubmit = async () => {
    };
    return (
        <div>
            <PageTitle title="Back" />
            <UserPrivateComponent permission={"readAll-payroll"}>
                <Card className="mt-5">
                    <div className="flex justify-end">
                        {/* <h1 className="text-base text-color-2 items-center mr-2 mt-1">
                            {" "}
                            Select Month :{" "}
                        </h1> */}
                        {/* <DatePicker
                            format={"MMM"}
                            className=" mr-5"
                            style={{ maxWidth: "200px" }}
                            picker="month"
                            defaultValue={dayjs()}
                            onChange={onMonthChange}
                        />
                        <h1 className="text-base text-color-2 items-center mr-2 mt-1">
                            {" "}
                            Select Year :{" "}
                        </h1>
                        <DatePicker
                            format={"YYYY"}
                            picker="year"
                            style={{ maxWidth: "200px" }}
                            onChange={onYearChange}
                            defaultValue={dayjs()}
                        /> */}

                    </div>

                    <CustomTable
                        list={payroll}
                        loading={loader}
                    />

                    <div className="flex justify-end">
                        <Button
                            loading={loading}
                            type="primary"
                            size="large"
                            htmlType="sumbit"
                            onClick={OnSubmit}
                            className="mt-5 text-end"
                        >
                            Generate Payslip
                        </Button>
                    </div>
                </Card>
            </UserPrivateComponent>
        </div>
    );
};

export default UploadPaySlip;
